// React
import React, { useState, useEffect } from 'react';

// 3Box
import ProfileHover from 'profile-hover';

// Material UI
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import red from '@material-ui/core/colors/red';
import blue from '@material-ui/core/colors/blue';
import grey from '@material-ui/core/colors/grey';
import RewardIcon from '@material-ui/icons/CheckCircleOutlined';

// BN.js
const BN = require('bn.js');

// Colors
const CHALLENGER_COLOR = red[500];
const OWNER_COLOR = blue[600];
const UNREVEALED_COLOR = grey[300];


function PageHeader () {
	return (
      <header className="App-header">
      	<Typography variant="h6">FOAM Map Challenge Explorer, powered by The Graph</Typography>
      	<Typography variant="body2"><Link href="https://github.com/blocklytics/foam-subgraph" target="_blank" color="inherit">Github</Link> | <Link href="https://thegraph.com/explorer/subgraph/blocklytics/foam" target="_blank" color="inherit">Subgraph</Link></Typography>
      </header>
	)
}

function tokensFor(number, suffix=" FOAM") {
	return `${(number * 10 ** -18).toLocaleString([], { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + suffix}`
}

async function fetchGraphData(query) {
	const baseUrl = "https://api.thegraph.com/subgraphs/name/blocklytics/foam"
	var result;
	
	if (!query) return
	
	await fetch(baseUrl, {
  	method: 'POST',
  	headers: { 'Content-Type': 'application/json' },
  	body: JSON.stringify({ query: query }),
	})
  .then(r => r.json())
  .then(r => {
  	result = r.data
  });
  
  return result
}

async function fetchFoamData(challengeId) {
	const baseUrl = `https://map-api-direct.foam.space/challenge/${challengeId}/doc`
	var result;
	
	await fetch(baseUrl)
	.then(r => r.json())
	.then(r => {
		result = r.data.reason
	});
	
	return result
}

function ChallengeParticipants (props) {
	if (!props.challenge) return null
	
	const challenger = props.challenge.creator.id
	const owner = props.challenge.listing.owner.id
	
	return (
		<Grid container direction="row" justify="center" alignItems="center" wrap="nowrap" spacing={10}>
			<Grid item className="challenger">
				<Account address={ challenger } />
			</Grid>
			<Grid item>
				<Typography variant="h6">VS</Typography>
			</Grid>
			<Grid item className="owner">
				<Account address={ owner } />
			</Grid>
		</Grid>
	)
}

function ChallengeHeader (props) {
	if (!props.challenge) return null
	
	const { id, status } = props.challenge
	
	var outcome;
	switch(status) {
		case "Successful":
			outcome = "This challenge is complete. The Challenger won."
			break;
		case "Failed":
			outcome = "This challenge is complete. The Challenger lost."
			break;
		default:
			console.log(props.status, "needs a subtitle")
	}
	
	const challengeTitle = `Challenge #${parseInt(id)}`
	
	return (
		<>
			<Typography variant="h3">{ challengeTitle }</Typography>
			<Typography variant="body1">{ outcome }</Typography>
		</>
	)
}

function TokensAtStake (props) {
	if (!props.challenge) return null
	
	const { rewardPool } = props.challenge
	
	return (
		<>
			<Typography variant="h3">{ tokensFor(rewardPool) }</Typography>
			<Typography variant="body1">Tokens at stake</Typography>
		</>
	)
}

function Account (props) {
	const { address } = props;

	return (
	  <ProfileHover fullWidth address={address} showName={true} noImgs={true} orientation="bottom" />
	)
}

function ResultBar (props) {
	if (!props.challenge) return null
	
	const { votes, quorumRequired } = props.challenge
	
	Object.filter = (obj, predicate) => 
    Object.keys(obj)
          .filter( key => predicate(obj[key]) )
          .reduce( (res, key) => (res[key] = obj[key], res), [] );
	
	const votesForChallenger = Object.filter(votes, vote => vote.isRevealed && vote.isForChallenge)
	const votesForOwner = Object.filter(votes, vote => vote.isRevealed && !vote.isForChallenge)
	const unrevealedVotes = Object.filter(votes, vote => !vote.isRevealed)
	
	const maxVotes = votes[0].voteAmount
	
	return (
		<Grid container direction="row" justify="space-apart" alignItems="flex-start" wrap="nowrap" spacing={0} style={{ minWidth: 800 }}>
		<Tooltip title="Absolute quorum - pass this line to win">
			<div className="quorum-line" style={{ left: `calc(100% - ${quorumRequired}%)` }}/>
		</Tooltip>
			{ votesForChallenger && votesForChallenger.map(item => (
				<Tooltip title={tokensFor(item.voteAmount)}>
					<div className="progress-bar-segment" style={{ backgroundColor: CHALLENGER_COLOR, width: `calc(${(item.voteAmount / maxVotes) * 100}% - 1px)` }} />
				</Tooltip>
			))}
			
			{ unrevealedVotes && unrevealedVotes.map(item => (
				<Tooltip title={tokensFor(item.voteAmount)}>
				<div className="progress-bar-segment" style={{ backgroundColor: UNREVEALED_COLOR, width: `calc(${(item.voteAmount / maxVotes) * 100}% - 1px)` }} />
				</Tooltip>
			))}
			
			{ votesForOwner && votesForOwner.map(item => (
				<Tooltip title={tokensFor(item.voteAmount)}>
				<div className="progress-bar-segment" style={{ backgroundColor: OWNER_COLOR, width: `calc(${(item.voteAmount / maxVotes) * 100}% - 1px)` }} />
				</Tooltip>
			))}
		</Grid>
	)
}

function VotingReward (props) {
	const { wonChallenge } = props.vote
	
	if (!wonChallenge) return null
	
	return <RewardIcon className="reward-indicator" />
}

function Voters (props) {
	if (!props.challenge) return null
	
	const { votes, totalVotesFor, totalVotesAgainst, totalVotesCommitted, totalVotesRevealed } = props.challenge
	
	Object.filter = (obj, predicate) => 
    Object.keys(obj)
          .filter( key => predicate(obj[key]) )
          .reduce( (res, key) => (res[key] = obj[key], res), [] );
	
	const votesForChallenger = Object.filter(votes, vote => vote.isRevealed && vote.isForChallenge)
	const votesForOwner = Object.filter(votes, vote => vote.isRevealed && !vote.isForChallenge)
	const unrevealedVotes = Object.filter(votes, vote => !vote.isRevealed)
	
	const maxVotes = votes[0].voteAmount
	
	const totalUnrevealedVotes = totalVotesCommitted - totalVotesRevealed
	
	return (
		<Grid container direction="row" justify="space-apart" alignItems="flex-start" wrap="nowrap" spacing={0} style={{ minWidth: 800 }}>
			<Grid item container direction="column" justify="flex-start" alignItems="stretch" wrap="nowrap" spacing={2} className="forChallenger" xs={4}>
				<Typography variant="h6">Votes for Challenger</Typography>
				<Typography variant="caption">{tokensFor(totalVotesFor)}</Typography>
					{votesForChallenger && votesForChallenger.map(item => (
						<Grid item style={{ marginTop: -44 }}>
							<div className="voter-contribution-bar" style={{ backgroundColor: CHALLENGER_COLOR, width: `calc(${(item.voteAmount / maxVotes) * 100}% + 36px)`, left: 36, textAlign: 'right' }} />
							<Account address={item.voter.id} />
							<VotingReward vote={item} />
						</Grid>
					))}
			</Grid>
			<Grid item container direction="column" justify="flex-start" alignItems="stretch" wrap="nowrap" spacing={2} className="unrevealed" xs={4}>
				<Typography variant="h6">Unrevealed</Typography>
				<Typography variant="caption">{tokensFor(totalUnrevealedVotes)}</Typography>
					{unrevealedVotes && unrevealedVotes.map(item => (
						<Grid item style={{ marginTop: -44 }}>
							<div className="voter-contribution-bar" style={{ backgroundColor: UNREVEALED_COLOR, width: `calc(${item.voteAmount / maxVotes * 100}% + 72px)` }} />
							<Account address={item.voter.id} />
						</Grid>
					))}
			</Grid>
			<Grid item container direction="column" justify="flex-start" alignItems="stretch" wrap="nowrap" spacing={2} className="forOwner" xs={4}>
					<Typography variant="h6">Votes for Owner</Typography>
					<Typography variant="caption">{tokensFor(totalVotesAgainst)}</Typography>
					{votesForOwner && votesForOwner.map(item => (
						<Grid item xs={12} style={{ marginTop: -44 }}>
							<div className="voter-contribution-bar" style={{ backgroundColor: OWNER_COLOR, marginLeft: `calc(${100 - item.voteAmount / maxVotes * 100}% - 72px)`, width: `calc(${item.voteAmount / maxVotes * 100}% + 36px)` }} />
							<Account address={item.voter.id} />
							<VotingReward vote={item} />
						</Grid>
					))}
			</Grid>
		</Grid>
	)
}

function App() {
	const [selectedChallenge, setSelectedChallenge] = useState();
	const [selectedChallengeReason, setSelectedChallengeReason] = useState();
	const [selectedChallengeId, setSelectedChallengeId] = useState( "0x1ee" );
	
	const QUERY_FOR_CHALLENGE = `
{
  challenge(id: "${selectedChallengeId}") {
    id 
    listing {
    	owner { id }
    }
    creator { id } 
    listing { id } 
    status 
    createdAtTimestamp 
    stake
    rewardPool
    quorumRequired
    votes(orderBy: voteAmount, orderDirection: desc) {
      id
      voter {
        id
      }
      isRevealed
      isForChallenge
      voteAmount
      wonChallenge
      rewardAmount
      rewardClaimed
    }
    totalVotesFor
    totalVotesAgainst
    totalVotesCommitted
    totalVotesRevealed
  } 
}
	`
	
	useEffect(() => {
		async function fetchActiveChallenge() {
			const result = await fetchGraphData(QUERY_FOR_CHALLENGE)
			setSelectedChallenge(result.challenge)

			// We pull the metadata about the challenge from FOAM API (IPFS mirror)
			const challengeReason = await fetchFoamData(result.challenge.id)
			setSelectedChallengeReason(challengeReason)
		}
		
		fetchActiveChallenge()
	}, [selectedChallengeId])
	
  return (
    <div className="App">	
    	<Grid container direction="column" justify="flex-start" alignItems="center" spacing={10}>
      	<Grid item><PageHeader /></Grid>
      	<Grid item>
      		<Grid container direction="row" justify="space-between" alignItems="center">
						<Button size="large" onClick={() => setSelectedChallengeId('0x' + (parseInt(selectedChallengeId, 16) - 1).toString(16))}>Prev</Button>
						<Button size="large" onClick={() => setSelectedChallengeId("0x1ee")}>0x1ee</Button>
						<Button size="large" onClick={() => setSelectedChallengeId("0x200")}>0x200</Button>
						<Button size="large" onClick={() => setSelectedChallengeId('0x' + (parseInt(selectedChallengeId, 16) + 1).toString(16))}>Next</Button>
					</Grid>
				</Grid>
      	<Grid item><ChallengeHeader challenge={ selectedChallenge } /></Grid>
      	<Grid item><ChallengeParticipants challenge={ selectedChallenge } /></Grid>
      	<Grid item><TokensAtStake challenge={ selectedChallenge } /></Grid>
      	<Grid item><ResultBar challenge={ selectedChallenge } /></Grid>
      	<Grid item><Voters challenge={ selectedChallenge } /></Grid>
      </Grid>
    </div>
  );
}

export default App;


//       	<Grid item>
// 					<Typography variant="h6">Why we participated</Typography>
// 					<Typography variant="body1" paragraph style={{ maxWidth: 600}}>Our company <Link href="https://blocklytics.org/" target="_blank">Blocklytics</Link> spends a great deal of resources on indexing blockchain data. We are continually researching better ways to gather and use data.</Typography>
// 					<Typography variant="h6">Our demo project</Typography>
// 					<Typography variant="body1" paragraph style={{ maxWidth: 600}}>Cryptoeconomic systems promise a new model of work. We are especially familiar with the FOAM Map, where challengers try to earn rewards by convincing voters that a point is invalid.</Typography>
// 					<Typography variant="body1" paragraph style={{ maxWidth: 600}}>The voting system uses a commit/reveal mechanism. Challenges with significant rewards are exciting! We enhance that excitment by using motifs from games (e.g. framing a challenge as "1 vs 1").</Typography>
// 					<Typography variant="body1" paragraph style={{ maxWidth: 600}}>For FOAM users, this new view provides a way of tracking how the voting is going. This can even save gas costs -- if your vote will not matter, you do not have to spend gas.</Typography>
// 					<Typography variant="body1" paragraph style={{ maxWidth: 600}}>There is an additional reputational element involved in the dashboard. Known, trusted cartographers are easy to identify through their <Link href="https://3box.io" target="_blank">3Box Profiles</Link>. This allows voters to better predict the outcome of the challenge and act accordingly.</Typography>
// 					<Typography variant="h6">Looking ahead</Typography>
// 					<Typography variant="body1" paragraph style={{ maxWidth: 600}}>We see an opportunity to replace the voting vizualization on our site <Link href="https://foam.tools/#/challenges/494" target="_blank">FOAM Tools</Link> and give users an option to interact with the voting contract directly. We are open to using The Graph for future projects.</Typography>
// 					<Divider />
//       	</Grid>